import { CSSProperties } from 'react';

export const layoutStyles = {
  mainLayout: {
    minHeight: 'calc(100vh - 5px)',
    marginTop: '5px',
  } as CSSProperties,

  sider: {
    position: 'fixed' as const,
    left: 0,
    top: 5,
    bottom: 0,
    zIndex: 1000,
  } as CSSProperties,

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px 48px',
    flexShrink: 0,
  } as CSSProperties,

  logo: {
    width: '100%',
    margin: '0 32px',
  } as CSSProperties,

  navigationContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    flex: 1,
    overflow: 'hidden',
  } as CSSProperties,

  primaryNavigation: {
    flex: 1,
    overflow: 'auto',
  } as CSSProperties,

  secondaryNavigation: {
    flexShrink: 0,
  } as CSSProperties,

  menuSeparator: {
    height: '1px',
    background: 'rgba(0, 0, 0, 0.06)',
    margin: '8px 16px',
  } as CSSProperties,

  menu: {
    border: 'none',
  } as CSSProperties,

  primaryMenu: {
    border: 'none',
    height: '100%',
  } as CSSProperties,

  content: {
    background: 'transparent',
    minHeight: 'calc(100vh - 64px)',
  } as CSSProperties,

  contentPadding: {
    padding: '16px',
  } as CSSProperties,

  breadcrumb: {
    marginBottom: 16,
    color: '#000000d9',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '8px 16px',
    borderRadius: 20,
    backdropFilter: 'blur(10px)',
    display: 'inline-block',
  } as CSSProperties,

  demoContainer: {
    minHeight: 'calc(100vh - 64px - 32px - 32px - 16px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  pageContainer: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    minHeight: 'calc(100vh - 64px - 32px - 32px - 16px)',
    borderRadius: 8,
    padding: 24,
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
  } as CSSProperties,
};

export const siderStyles = `
  .ant-layout-sider-children {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }
`;